import { render, staticRenderFns } from "./DeleteGoNoGoItemDialog.vue?vue&type=template&id=58a0cff7"
import script from "./DeleteGoNoGoItemDialog.vue?vue&type=script&lang=js"
export * from "./DeleteGoNoGoItemDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteGoNoGoItemDialog.vue?vue&type=style&index=0&id=58a0cff7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports